import React, { useState } from "react";

const API_URL =
  "https://6708d2de8e86a8d9e4302ef8.mockapi.io/pubgs/sss";

const Sikayet = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormData((previous) => ({
      ...previous,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const name = formData.name.trim();
    const email = formData.email.trim();
    const message = formData.message.trim();

    if (!name || !email || !message) {
      setIsError(true);
      setResponseMessage("Lütfen bütün sahələri doldurun!");
      return;
    }

    setIsLoading(true);
    setResponseMessage("");
    setIsError(false);

    const complaintData = {
      name,
      email,
      message,
    };

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(complaintData),
      });

      if (!response.ok) {
        throw new Error("Bir xəta baş verdi!");
      }

      setResponseMessage("Şikayətiniz uğurla göndərildi!");
      setIsError(false);

      setFormData({
        name: "",
        email: "",
        message: "",
      });
    } catch (error) {
      setResponseMessage(
        "Şikayət göndərilərkən bir səhv baş verdi!"
      );
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main
      className="
        relative min-h-screen w-full overflow-hidden
        bg-[#f6f7fb]
        text-slate-900
        transition-colors duration-300
        dark:bg-[#05030a]
        dark:text-white
      "
    >
      {/* =====================================================
          BACKGROUND EFFECTS
      ===================================================== */}

      {/* Grid */}
      <div
        className="
          pointer-events-none
          absolute inset-0
          opacity-40
          dark:opacity-[0.16]
        "
        style={{
          backgroundImage: `
            linear-gradient(rgba(139,92,246,0.08) 1px, transparent 1px),
            linear-gradient(90deg, rgba(34,211,238,0.08) 1px, transparent 1px)
          `,
          backgroundSize: "32px 32px",
        }}
      />

      {/* Purple glow */}
      <div
        className="
          pointer-events-none
          absolute -left-24 top-20
          h-64 w-64
          rounded-full
          bg-purple-500/10
          blur-[100px]
          dark:bg-purple-600/15
        "
      />

      {/* Cyan glow */}
      <div
        className="
          pointer-events-none
          absolute -right-24 bottom-20
          h-64 w-64
          rounded-full
          bg-cyan-400/10
          blur-[100px]
          dark:bg-cyan-500/10
        "
      />

      {/* Gold glow */}
      <div
        className="
          pointer-events-none
          absolute left-1/2 top-1/2
          h-48 w-48
          -translate-x-1/2
          -translate-y-1/2
          rounded-full
          bg-[#d6b36a]/5
          blur-[100px]
          dark:bg-[#d6b36a]/10
        "
      />

      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div
        className="
          relative z-10
          mx-auto flex w-full max-w-3xl
          flex-col items-center
          px-3 py-7
          sm:px-5 sm:py-10
          md:px-7 md:py-14
        "
      >
        {/* =================================================
            HEADER
        ================================================= */}

        <div className="mb-5 text-center sm:mb-7">
          {/* Badge */}
          <div
            className="
              mx-auto mb-3
              inline-flex items-center gap-2
              rounded-full
              border border-[#d6b36a]/20
              bg-white/70
              px-3 py-1
              text-[9px]
              font-bold
              uppercase
              tracking-[0.28em]
              text-[#9b7836]
              backdrop-blur-md
              dark:border-[#d6b36a]/20
              dark:bg-[#0d0915]
              dark:text-[#d6b36a]
              sm:px-4 sm:py-1.5
              sm:text-[10px]
            "
          >
            <span
              className="
                h-1.5 w-1.5
                rounded-full
                bg-purple-500
                shadow-[0_0_10px_rgba(139,92,246,0.8)]
              "
            />

            FF QADİR
          </div>

          {/* Title */}
          <h1
            className="
              text-2xl
              font-black
              tracking-tight
              text-slate-900
              dark:text-white
              sm:text-3xl
              md:text-4xl
            "
          >
            Şikayət{" "}
            <span
              className="
                bg-gradient-to-r
                from-purple-500
                via-fuchsia-500
                to-cyan-400
                bg-clip-text
                text-transparent
              "
            >
              və Təklif
            </span>
          </h1>

          {/* Divider */}
          <div className="mx-auto mt-3 flex items-center justify-center gap-2">
            <div className="h-px w-7 bg-gradient-to-r from-transparent to-[#d6b36a]" />

            <div
              className="
                h-1.5 w-1.5
                rotate-45
                bg-[#d6b36a]
                shadow-[0_0_10px_rgba(214,179,106,0.7)]
              "
            />

            <div className="h-px w-7 bg-gradient-to-l from-transparent to-[#d6b36a]" />
          </div>

          <p
            className="
              mx-auto mt-2
              max-w-md
              text-[10px]
              leading-5
              text-slate-500
              dark:text-white/35
              sm:text-xs
              md:text-sm
            "
          >
            Təcrübənizi bizimlə paylaşın. Sizin fikriniz bizim üçün
            önəmlidir.
          </p>
        </div>

        {/* =================================================
            FORM CARD
        ================================================= */}

        <div className="relative w-full">
          {/* Card glow */}
          <div
            className="
              pointer-events-none
              absolute -inset-1
              rounded-[24px]
              bg-gradient-to-r
              from-purple-500/10
              via-transparent
              to-cyan-500/10
              blur-xl
              dark:from-purple-500/10
              dark:to-cyan-500/10
            "
          />

          <form
            onSubmit={handleSubmit}
            className="
              relative
              overflow-hidden
              rounded-[20px]
              border
              border-slate-200
              bg-white/80
              p-4
              shadow-[0_20px_60px_rgba(15,23,42,0.08)]
              backdrop-blur-xl
              dark:border-white/[0.06]
              dark:bg-[#090611]
              dark:shadow-[0_25px_70px_rgba(0,0,0,0.55)]
              sm:rounded-[24px]
              sm:p-6
              md:p-7
            "
          >
            {/* Top neon line */}
            <div
              className="
                absolute left-0 right-0 top-0
                h-px
                bg-gradient-to-r
                from-transparent
                via-purple-500/70
                to-transparent
              "
            />

            {/* Small corner decoration */}
            <div
              className="
                absolute right-0 top-0
                h-24 w-24
                rounded-full
                bg-purple-500/5
                blur-3xl
                dark:bg-purple-500/10
              "
            />

            {/* Form header */}
            <div
              className="
                relative mb-5
                flex items-center gap-3
                border-b
                border-slate-200
                pb-4
                dark:border-white/[0.05]
                sm:mb-6
                sm:pb-5
              "
            >
              <div
                className="
                  flex h-10 w-10
                  shrink-0
                  items-center justify-center
                  rounded-xl
                  border border-purple-500/20
                  bg-purple-500/10
                  text-lg
                  dark:border-purple-500/20
                  dark:bg-purple-500/10
                "
              >
                💬
              </div>

              <div>
                <h2
                  className="
                    text-sm
                    font-extrabold
                    text-slate-900
                    dark:text-white
                    sm:text-base
                  "
                >
                  Bizə yaz
                </h2>

                <p
                  className="
                    mt-0.5
                    text-[9px]
                    text-slate-500
                    dark:text-white/30
                    sm:text-[10px]
                  "
                >
                  Müraciətinizi aşağıdakı formdan göndərin.
                </p>
              </div>
            </div>

            {/* =================================================
                NAME
            ================================================= */}

            <div className="relative mb-4 sm:mb-5">
              <label
                htmlFor="name"
                className="
                  mb-1.5
                  block
                  text-[10px]
                  font-bold
                  uppercase
                  tracking-[0.08em]
                  text-slate-600
                  dark:text-white/65
                  sm:text-xs
                "
              >
                Adınız
              </label>

              <div className="relative">
                <span
                  className="
                    pointer-events-none
                    absolute left-3
                    top-1/2
                    -translate-y-1/2
                    text-xs
                    text-slate-400
                    dark:text-white/25
                  "
                >
                  👤
                </span>

                <input
                  type="text"
                  id="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Adınızı daxil edin..."
                  required
                  className="
                    w-full
                    rounded-xl
                    border
                    border-slate-200
                    bg-slate-50
                    py-2.5
                    pl-9
                    pr-3
                    text-xs
                    text-slate-900
                    outline-none
                    placeholder:text-slate-400
                    transition-all
                    duration-200
                    focus:border-purple-500
                    focus:bg-white
                    focus:ring-4
                    focus:ring-purple-500/10
                    dark:border-white/[0.06]
                    dark:bg-[#06040b]
                    dark:text-white
                    dark:placeholder:text-white/20
                    dark:focus:border-purple-500/50
                    dark:focus:bg-[#08050e]
                    sm:py-3
                    sm:text-sm
                  "
                />
              </div>
            </div>

            {/* =================================================
                EMAIL
            ================================================= */}

            <div className="relative mb-4 sm:mb-5">
              <label
                htmlFor="email"
                className="
                  mb-1.5
                  block
                  text-[10px]
                  font-bold
                  uppercase
                  tracking-[0.08em]
                  text-slate-600
                  dark:text-white/65
                  sm:text-xs
                "
              >
                E-poçt
              </label>

              <div className="relative">
                <span
                  className="
                    pointer-events-none
                    absolute left-3
                    top-1/2
                    -translate-y-1/2
                    text-xs
                    text-slate-400
                    dark:text-white/25
                  "
                >
                  @
                </span>

                <input
                  type="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="E-poçt ünvanınızı daxil edin..."
                  required
                  className="
                    w-full
                    rounded-xl
                    border
                    border-slate-200
                    bg-slate-50
                    py-2.5
                    pl-9
                    pr-3
                    text-xs
                    text-slate-900
                    outline-none
                    placeholder:text-slate-400
                    transition-all
                    duration-200
                    focus:border-cyan-500
                    focus:bg-white
                    focus:ring-4
                    focus:ring-cyan-500/10
                    dark:border-white/[0.06]
                    dark:bg-[#06040b]
                    dark:text-white
                    dark:placeholder:text-white/20
                    dark:focus:border-cyan-500/50
                    dark:focus:bg-[#08050e]
                    sm:py-3
                    sm:text-sm
                  "
                />
              </div>
            </div>

            {/* =================================================
                MESSAGE
            ================================================= */}

            <div className="relative mb-5 sm:mb-6">
              <div className="mb-1.5 flex items-center justify-between">
                <label
                  htmlFor="message"
                  className="
                    block
                    text-[10px]
                    font-bold
                    uppercase
                    tracking-[0.08em]
                    text-slate-600
                    dark:text-white/65
                    sm:text-xs
                  "
                >
                  Şikayətiniz / Təklifiniz
                </label>

                <span
                  className="
                    text-[8px]
                    text-slate-400
                    dark:text-white/20
                    sm:text-[9px]
                  "
                >
                  Maksimum rahat yazın
                </span>
              </div>

              <div className="relative">
                <span
                  className="
                    pointer-events-none
                    absolute left-3
                    top-3
                    text-xs
                    text-slate-400
                    dark:text-white/25
                  "
                >
                  ✦
                </span>

                <textarea
                  id="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Şikayətiniz və ya təklifinizi yazın..."
                  required
                  className="
                    w-full
                    resize-none
                    rounded-xl
                    border
                    border-slate-200
                    bg-slate-50
                    px-3
                    py-2.5
                    pl-9
                    text-xs
                    leading-5
                    text-slate-900
                    outline-none
                    placeholder:text-slate-400
                    transition-all
                    duration-200
                    focus:border-[#d6b36a]
                    focus:bg-white
                    focus:ring-4
                    focus:ring-[#d6b36a]/10
                    dark:border-white/[0.06]
                    dark:bg-[#06040b]
                    dark:text-white
                    dark:placeholder:text-white/20
                    dark:focus:border-[#d6b36a]/40
                    dark:focus:bg-[#08050e]
                    sm:py-3
                    sm:text-sm
                    sm:leading-6
                  "
                />
              </div>
            </div>

            {/* =================================================
                SUBMIT
            ================================================= */}

            <button
              type="submit"
              disabled={isLoading}
              className="
                group
                relative
                w-full
                overflow-hidden
                rounded-xl
                border
                border-purple-400/20
                bg-gradient-to-r
                from-purple-600
                via-fuchsia-600
                to-purple-600
                px-4
                py-2.5
                text-xs
                font-extrabold
                text-white
                shadow-[0_10px_30px_rgba(139,92,246,0.20)]
                transition-all
                duration-300
                hover:-translate-y-0.5
                hover:shadow-[0_15px_40px_rgba(139,92,246,0.30)]
                disabled:cursor-not-allowed
                disabled:opacity-60
                sm:py-3
                sm:text-sm
              "
            >
              {/* Button shine */}
              <span
                className="
                  absolute inset-y-0
                  -left-full
                  w-1/2
                  skew-x-[-20deg]
                  bg-white/10
                  transition-all
                  duration-700
                  group-hover:left-[120%]
                "
              />

              <span className="relative z-10 flex items-center justify-center gap-2">
                {isLoading ? (
                  <>
                    <span
                      className="
                        h-3.5 w-3.5
                        animate-spin
                        rounded-full
                        border-2
                        border-white/30
                        border-t-white
                      "
                    />
                    Göndərilir...
                  </>
                ) : (
                  <>
                    <span>Göndər</span>
                    <span className="text-base transition-transform duration-300 group-hover:translate-x-1">
                      →
                    </span>
                  </>
                )}
              </span>
            </button>

            {/* =================================================
                RESPONSE
            ================================================= */}

            {responseMessage && (
              <div
                className={`
                  mt-4
                  flex
                  items-center
                  gap-2
                  rounded-xl
                  border
                  px-3
                  py-2.5
                  text-[10px]
                  font-semibold
                  sm:text-xs

                  ${
                    isError
                      ? `
                        border-red-500/20
                        bg-red-500/5
                        text-red-500
                        dark:border-red-500/20
                        dark:bg-red-500/10
                        dark:text-red-400
                      `
                      : `
                        border-emerald-500/20
                        bg-emerald-500/5
                        text-emerald-600
                        dark:border-emerald-500/20
                        dark:bg-emerald-500/10
                        dark:text-emerald-400
                      `
                  }
                `}
              >
                <span
                  className={`
                    flex h-6 w-6
                    shrink-0
                    items-center justify-center
                    rounded-lg
                    ${
                      isError
                        ? "bg-red-500/10"
                        : "bg-emerald-500/10"
                    }
                  `}
                >
                  {isError ? "!" : "✓"}
                </span>

                <span>{responseMessage}</span>
              </div>
            )}

            {/* Bottom info */}
            <div
              className="
                mt-4
                flex
                items-center
                justify-center
                gap-1.5
                text-[8px]
                text-slate-400
                dark:text-white/20
                sm:text-[9px]
              "
            >
              <span className="text-emerald-500">●</span>
              Müraciətiniz təhlükəsiz şəkildə göndərilir
            </div>
          </form>
        </div>

        {/* =================================================
            BOTTOM MINI CARD
        ================================================= */}

        <div
          className="
            mt-5
            flex
            items-center
            justify-center
            gap-2
            rounded-xl
            border
            border-slate-200
            bg-white/60
            px-4
            py-2.5
            text-center
            dark:border-white/[0.04]
            dark:bg-[#090611]
            sm:mt-6
          "
        >
          <span className="text-sm">💜</span>

          <p
            className="
              text-[9px]
              text-slate-500
              dark:text-white/30
              sm:text-[10px]
            "
          >
            Fikirləriniz FF QADİR üçün dəyərlidir.
          </p>
        </div>
      </div>
    </main>
  );
};

export default Sikayet;